import { numberFormat } from '@nike/i18n-core';
import useLocale from './localeHook';
import useIdentity from './identityHook';

function useFormatPrice({
  currentPrice: finalPrice,
  initialPrice: listPrice,
  employeePrice,
  currency,
  discountPercentage,
  employeeDiscountPercentage,
}) {
  const { userProfile } = useIdentity();
  const onSale = discountPercentage > 0;
  const { hreflang, country } = useLocale();
  const isIndia = country.toLowerCase() === 'in';

  const priceOptions = {
    currency,
    encourageWholeNumbers: !isIndia,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  const finalPriceFormatted =
    finalPrice && numberFormat(hreflang, Number(finalPrice), priceOptions);
  const listPriceFormatted = listPrice && numberFormat(hreflang, Number(listPrice), priceOptions);
  const employeePriceFormatted =
    employeePrice && numberFormat(hreflang, Number(employeePrice), priceOptions);

  let price = isIndia ? `MRP : ${finalPriceFormatted}` : finalPriceFormatted;
  let discountPrice;
  let addendum1;

  // Required to display original pricing in India if on sale
  // MRP is the maximum retail price, so the discounted price here doesn't include MRP text
  // Only the list price has the MRP value.
  if (isIndia && onSale) {
    price = finalPriceFormatted;
    addendum1 = `MRP : ${listPriceFormatted}`;
  } else if (
    userProfile?.userType === 'SWOOSH' &&
    employeePrice &&
    employeeDiscountPercentage > 0
  ) {
    discountPrice = employeePriceFormatted;
  }

  return { price, discountPrice, addendum1 };
}

export default useFormatPrice;
